export enum SCROLL_KEYS {
	VIDEO = 'video',
	FOOTER = 'footer',
}
